import script from "./ChartPremium.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartPremium.vue?vue&type=script&setup=true&lang=js"

import "./ChartPremium.vue?vue&type=style&index=0&id=d270b4a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d270b4a0"]])

export default __exports__